<template>
  <div class="flex items-center gap-2">
    <ToggleGroup
      :modelValue="modelValue"
      :options="dataSourceOptions"
      @update:modelValue="$emit('update:modelValue', $event)"
    />
    <button
      class="flex items-center justify-center w-6 h-6 rounded-full bg-gray-200 text-gray-500 hover:bg-gray-300 hover:text-gray-700 transition-colors cursor-pointer text-xs font-bold"
      @click="showInfoModal = true"
    >
      ?
    </button>
    <DataSourceInfoModal :open="showInfoModal" @close="showInfoModal = false" />
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { ToggleGroup } from "@estaly/ui";
import DataSourceInfoModal from "@/components/analytics/DataSourceInfoModal";
import { ShoppingBagIcon, ClipboardListIcon, TrendingUpIcon } from "@heroicons/vue/outline";

export default {
  components: { ToggleGroup, DataSourceInfoModal },

  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },

  emits: ["update:modelValue"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      showInfoModal: false,
    };
  },

  computed: {
    dataSourceOptions() {
      return [
        { value: "gross_sales", label: this.t("data_source_gross_sales"), icon: TrendingUpIcon },
        { value: "contracts", label: this.t("data_source_contracts"), icon: ShoppingBagIcon },
        { value: "leads", label: this.t("data_source_leads"), icon: ClipboardListIcon },
      ];
    },
  },
};
</script>

<i18n src="./DataSourceToggle.i18n.json"></i18n>
